import { statesRequest } from "./statesRequest";

export default statesRequest;
